import { useState } from "react";
import { faqs } from "@/mocks/films";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section id="faq" className="w-full bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-3xl mx-auto">
          <header className="text-center">
            <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label text-secondary-800 bg-secondary-100 px-3 py-1.5 rounded-full">
              <i className="ri-question-line" aria-hidden="true"></i>
              常见问题
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug">
              关于这个页面，你可能想问的
            </h2>
          </header>

          <div className="mt-9 space-y-3">
            {faqs.map((item) => {
              const open = openId === item.id;
              return (
                <div key={item.id} className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : item.id)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.q}</span>
                    <span
                      className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-full transition-transform ${
                        open ? "bg-primary-500 text-background-50 rotate-180" : "bg-background-300 text-foreground-700"
                      }`}
                    >
                      <i className="ri-arrow-down-s-line" aria-hidden="true"></i>
                    </span>
                  </button>
                  {open && (
                    <div className="px-4 md:px-5 pb-4 -mt-1">
                      <p className="text-sm md:text-[15px] text-foreground-600 leading-relaxed border-t border-background-200 pt-3">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}